import { csHttp } from "./http";

export const csSendOtp = (phone) =>
  csHttp.post("/api/verify/send-otp", { phone }).then(r => r.data);

export const csConfirmOtp = (phone, otp) =>
  csHttp.post("/api/verify/confirm-otp", { phone, otp }).then(r => r.data);

export const csSubmitDocs = (payload) =>
  csHttp.post("/api/verify/submit-docs", payload).then(r => r.data);
